import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import BlogList from '../components/BlogList';
import BlogPost from '../components/BlogPost';
import { posts } from '../data/posts';

const BlogPostWrapper: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="max-w-screen-lg mx-auto px-8 py-16 text-center">
        <h1 className="text-4xl font-thin text-white mb-8">Post Not Found</h1>
        <p className="text-white/60 font-extralight">
          The blog post you're looking for doesn't exist.
        </p>
      </div>
    );
  }

  return <BlogPost post={post} />;
};

const Blog: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BlogList posts={posts} />} />
      <Route path="/:slug" element={<BlogPostWrapper />} />
    </Routes>
  );
};

export default Blog; 